import React from 'react';
import { Pressable, PressableProps, Text, View } from 'react-native';
import { calcSizeForTv } from 'utils/index';

import { ButtonProps } from '.';

import { getIconByName } from 'components/Icons';

export type MenuButtonProps = {
  isActivated?: boolean;
  isOpen?: boolean;
  setActiveMenuItem?: Function;
  setIsOpen?: Function;
  setIsSubmenuOpen?: Function;
  onButtonEnter?: () => void;
};

type SidebarMenuButtonProps = Omit<ButtonProps, 'gradientVariant' | 'variant' | 'backgroundColor'> &
  MenuButtonProps;

const SidebarMenuButton = React.forwardRef<PressableProps, SidebarMenuButtonProps>(
  (
    {
      children,
      iconStyle,
      iconType,
      isActivated,
      isFullWidth = false,
      isOpen,
      onButtonEnter,
      style,
      textStyle,
      textTransform,
      rounded = false,
      ...rest
    },
    ref
  ) => {
    const Icon = iconType ? getIconByName(iconType) : null;
    const contentColor = isActivated ? '#7A8CFF' : '#FFF';
    const iconProps = {
      ...iconStyle,
      color: contentColor,
    };

    return (
      <Pressable
        ref={ref}
        id="sidebar-menu__button"
        style={({ pressed }) => [
          {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: 'transparent',
            height: calcSizeForTv(60),
            paddingHorizontal: calcSizeForTv(16),
            marginVertical: calcSizeForTv(12),
            borderRadius: rounded ? 50 : 5,
            width: isFullWidth ? '100%' : undefined,
          },
          style,
          pressed && { backgroundColor: 'background: rgba(209, 215, 255, 0.20);' },
        ]}
        onPress={onButtonEnter}
        {...rest}>
        <View>{Icon && <Icon {...iconProps} />}</View>
        {children && (
          <Text
            numberOfLines={1}
            style={[
              {
                opacity: isOpen ? 1 : 0,
                paddingLeft: calcSizeForTv(16),
                fontSize: calcSizeForTv(20),
                fontWeight: '600',
                textTransform: textTransform,
                color: contentColor,
              },
              textStyle,
            ]}>
            {children}
          </Text>
        )}
      </Pressable>
    );
  }
);

export default SidebarMenuButton;
